import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { all_routes } from "Router/all_routes";
const UserMasterDetails = ({ userMasterData }) => {
  console.log("userMasterData in details", userMasterData);
  return (
    <div className="card table-list-card border-0">
      <h4 className="card-title">User Master Details</h4>
      <div className="card-body">
        <div className="row">
          <div className="col-md-12">
            <div className="table-responsive">
              <table className="table table-striped table-hover">
                <tbody>
                  <tr>
                    <td>UserID</td>
                    <td>{userMasterData?.[0]?.userID}</td>
                  </tr>
                  <tr>
                    <td>UserName</td>
                    <td>{userMasterData?.[0]?.userName}</td>
                  </tr>
                   <tr>
                    <td>Email ID</td>
                    <td>{userMasterData?.[0]?.emailId}</td>
                  </tr>
                  <tr>
                    <td>Location Code</td>
                    <td>{userMasterData?.[0]?.locationCode}</td>
                  </tr>
                  <tr>
                    <td>User Group Code</td>
                    <td>{userMasterData?.[0]?.userGroupCode}</td>
                  </tr>
                  <tr>
                    <td>Status</td>
                    <td>{userMasterData?.[0]?.isActive ? "Active" : "Inactive"}</td>
                  </tr>

                  <tr>
                    <td>User Locked</td>
                    <td>{userMasterData?.[0]?.isLocked ? "Yes" : "No"}</td>
                  </tr>

                   <tr>
                    <td>App PIN</td>
                    <td>{userMasterData?.[0]?.appPin}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

UserMasterDetails.propTypes = {
  userMasterData: PropTypes.object.isRequired,
};
export default UserMasterDetails;
